import Loadable from "react-loadable"
import Loading from "@/components/Loading"

export const Models = Loadable({
  loader: () => import("./Models"),
  loading: Loading
})
